import React from 'react'
import { Link } from 'react-router-dom'
import ShapeAnimation from '../../../ShapeAnimation'
const Internet_Banner = () => {
    return (
        <>
            <div className="internet-of-things-banner">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                            {/* <h1 class="banner-heading">IOT Company In India</h1> */}
                        </div>
                    </div>
                </div>
                <ShapeAnimation/>
            </div>

            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Internet Of Things
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default Internet_Banner